module.exports = __webpack_public_path__ + "img/italien2de.e341995a.png";